import { FiSearch } from "react-icons/fi";

export default function MovimientoFilters({
                                              filtros,
                                              setFiltros,
                                              onBuscar,
                                              cuentas = [],
                                              categorias = [],
                                          }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFiltros((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="filters-grid card-panel">
            <div>
                <label>Tipo de movimiento</label>
                <select name="tipo" value={filtros.tipo} onChange={handleChange}>
                    <option value="">Todos</option>
                    <option value="INGRESO">Ingreso</option>
                    <option value="GASTO">Gasto</option>
                </select>
            </div>

            <div>
                <label>Fecha inicio</label>
                <input
                    type="date"
                    name="fechaInicio"
                    value={filtros.fechaInicio}
                    onChange={handleChange}
                />
            </div>

            <div>
                <label>Fecha fin</label>
                <input
                    type="date"
                    name="fechaFin"
                    value={filtros.fechaFin}
                    onChange={handleChange}
                />
            </div>

            <div>
                <label>Cuenta</label>
                <select name="idCuenta" value={filtros.idCuenta} onChange={handleChange}>
                    <option value="">Todas las cuentas</option>
                    {cuentas.map((item) => {
                        const id = item.idCuenta ?? item.id_cuenta;
                        return (
                            <option key={id} value={id}>
                                {item.nombre}
                            </option>
                        );
                    })}
                </select>
            </div>

            <div>
                <label>Categoría</label>
                <select name="idCategoria" value={filtros.idCategoria} onChange={handleChange}>
                    <option value="">Todas las categorías</option>
                    {categorias.map((item) => {
                        const id = item.idCategoria ?? item.id_categoria;
                        return (
                            <option key={id} value={id}>
                                {item.nombre}
                            </option>
                        );
                    })}
                </select>
            </div>

            <div style={{ display: "flex", alignItems: "flex-end" }}>
                <button className="btn-primary" type="button" onClick={onBuscar}>
                    <FiSearch size={16} />
                    Buscar
                </button>
            </div>
        </div>
    );
}